import { CoreConfigService, Config_key } from './core/core.service';
import {
  Component,
  PLATFORM_ID,
  Inject,
  Injector,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  RouterState,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import moment  from 'moment';
import { BehaviorSubject, Subscription, Observable, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { LocalstorageService } from './core/Localstorage.service';
import { Setting_Model } from './core/core.model';
import { MatDialog } from '@angular/material/dialog';
import { DialogCommentComponent } from './shared/dialog-comment/dialog-comment.component';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DialogOpenapp } from './shared/dialog-openapp/dialog-openapp';
import { json } from 'express';

@Component({
  selector: 'kett-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy, AfterViewInit {
  title = 'app';

  RouterSub: Subscription;
  Blurcontent = false;
  HideComment = false;
  lang: string;
  constructor(
    private router: Router,
    private titleService: Title,
    private _ActivatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private _HttpClient: HttpClient,
    private _ChangeDetectorRef: ChangeDetectorRef,
    private _LocalstorageService: LocalstorageService,
    private _CoreConfigService: CoreConfigService,
    private toastr: ToastrService,
    private _TranslateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    if (isPlatformBrowser(this.platformId)) {

      const appTitle = this.titleService.getTitle();

      this.RouterSub = this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => {
            let child = this._ActivatedRoute.firstChild;

            if (window != undefined) window.scrollTo(0, 0);
            while (child.firstChild) {
              child = child.firstChild;
            }
            if (child.snapshot.data['title']) {
              return child.snapshot.data['title'];
            }
            return appTitle;
          })
        )
        .subscribe((ttl: string) => {
          if (isPlatformBrowser(this.platformId)) {
            this.lang = this._CoreConfigService.Setting.lang;
          }
          this.titleService.setTitle(ttl + ' - KEX Express Thailand');
        });
    }
  }

  ngOnDestroy() {
    if (this.RouterSub) this.RouterSub.unsubscribe();
  }

  ngOnInit() {
    moment.locale('en');
  }

  ShowDialogComment() {

    this.dialog
      .open(DialogCommentComponent, {
        height: 'auto',
        width: '600px',
        disableClose: true,
        autoFocus: false,
      })
      .afterClosed()
      .subscribe((req) => {
        if (req) {
          this._HttpClient
            .post(
              this._CoreConfigService.base_config.api_path +
                '/api/sys/comments',
              req
            )
            .subscribe((res) => {
              this.toastr.success('Thank you!');
              this.HideComment = true;
            });
        }
      });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.DetectDevice();
    }
  }

  parseScheme(s, device) {
    if (s === 'main') return '';

    if (s === 'tracking') return 'tracking';

    if (s === 'booking') return 'booking';

    var v;
    v = /tracking\?\w+/.exec(s);
    if (v !== null) {
      var name = device === 'ANDROID' ? 'consignment=' : '';
      return 'tracking?' + name + v[0].substring(9);
    }

    return 'main';
  }

  DetectDevice() {
    if (
      !this._CoreConfigService.Setting.last_alert_app ||
      this._CoreConfigService.Setting.last_alert_app <
        +moment().format('YYYYMM')
    ) {
      if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        this.UpdateLastAlertApp();
        this.LuachingApp(true);
        // this.ShowDialogApp(true);
      } else if (navigator.userAgent.match(/Android/i)) {
        this.ShowDialogApp(false);
        this.UpdateLastAlertApp();
      }
    }
  }

  UpdateLastAlertApp() {
    this._CoreConfigService.Setting.last_alert_app = +moment().format('YYYYMM');
    this._LocalstorageService.setItem(
      Config_key,
      JSON.stringify(this._CoreConfigService.Setting)
    );
  }

  open_store(storeUrl) {
    let tmp: any = window.location.href;
    window.location.href = storeUrl;
    setTimeout(function () {
      window.location = tmp;
    }, 1000);
  }

  LuachingApp(is_ios) {
    if (is_ios) {
      let storeUrl =
          'https://itunes.apple.com/th/app/kerry-express/id909585896?l=th',
        scheme = this.parseScheme('tracking', 'IOS'),
        fallbackUrl = encodeURIComponent(storeUrl),
        appUrl = 'keapp://' + scheme;
      this.open_store(appUrl);
    } else {
      let storeUrl = 'market://details?id=kerry.express.th.mobile.tracking',
        scheme = this.parseScheme('tracking', 'ANDROID'),
        fallbackUrl = encodeURIComponent(storeUrl),
        appUrl =
          'intent://' +
          scheme +
          '#Intent;scheme=keapp;package=kerry.express.th.mobile.tracking;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end;S.browser_fallback_url=' +
          fallbackUrl +
          ';end;';
      this.open_store(appUrl);
    }
  }

  ShowDialogApp(is_ios: boolean) {
    this.dialog
      .open(DialogOpenapp, {
        height: 'auto',
        width: '300px',
        disableClose: true,
        autoFocus: false,
        // backdropClass: 'mat-dialog-container-bg-backdrop',

        panelClass: 'mat-dialog-container-back-panel',
      })
      .afterClosed()
      .subscribe((req) => {
        if (req) {
          this.LuachingApp(false);
        }
      });
  }
}
